export const numeroFormateado =(numero=0)=>{
    return  numero.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    
}

